<script>
  import RingLoadingSpinner from './ringLoadingSpinner.svelte';
  import { fly } from 'svelte/transition';
  import { quintOut } from 'svelte/easing';

  import Fa from 'sveltejs-fontawesome';

  export let label;
  export let type = 'primary';
  export let size = 'normal';
  export let selected = false;
  export let isLoading = false;
  export let disabled = false;
  export let icon = null;
  export let iconPosition = 'left';
  export let iconMarginLeft = '0em';
  export let iconMarginRight = '0.5em';

  function getIconColor() {
    if (type === 'primary') {
      return '#fff';
    } else if (type === 'secondary' && !selected) {
      return '#423fd6';
    } else if (type === 'secondary' && selected) {
      return '#fff';
    } else {
      return '#fff';
    }
  }
</script>

<button
  tabindex="0"
  on:click
  disabled={disabled || isLoading}
  class="radius:m"
  class:primary={type === 'primary'}
  class:secondary={type === 'secondary'}
  class:secondary-selected={type === 'secondary' && selected}
  class:classic={type === 'classic'}
  class:minimalist={type === 'minimalist'}
  class:normal={size === 'normal'}
  class:small={size === 'small'}
>
  <div>
    {#if isLoading}
      <div
        class="loading-wrapper"
        in:fly={{ delay: 300, y: 10, duration: 250, easing: quintOut }}
        out:fly={{ delay: 0, y: -10, duration: 250, easing: quintOut }}
      >
        <RingLoadingSpinner size="1.5em" color={`${getIconColor()}`} />
      </div>
    {:else}
      <div
        in:fly={{ delay: 300, y: 10, duration: 250, easing: quintOut }}
        out:fly={{ delay: 0, y: -10, duration: 250, easing: quintOut }}
      >
        {#if icon && iconPosition.toLowerCase() === 'left'}
          <Fa
            {icon}
            size="1.2em"
            style={`margin-left: ${iconMarginLeft}; margin-right: ${iconMarginRight}; margin-top: -0.3em;`}
            color={`${getIconColor()}`}
          />
        {/if}
        {label}
        {#if icon && iconPosition.toLowerCase() === 'right'}
          <Fa
            {icon}
            size="1.2em"
            style={`margin-left: ${iconMarginLeft}; margin-right: ${iconMarginRight}; margin-top: -0.3em;`}
            color={`${getIconColor()}`}
          />
        {/if}
      </div>
    {/if}
  </div>
</button>

<style>
  button {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    position: relative;
    border: none;
    margin: 0;
    width: 100%;
    text-decoration: none;
    cursor: pointer;
    text-align: center;
    transition: background 250ms ease-in-out, transform 150ms ease, box-shadow 100ms ease, border 150ms ease,
      filter 100ms ease;
    -webkit-appearance: none;
    -moz-appearance: none;
    font-weight: 500;
    font-size: 0.9rem;
    margin: 0;
    border-radius: 10px;
  }
  button:not([disabled]):hover {
    cursor: pointer;
    filter: drop-shadow(0rem 0.625rem 1.5rem rgba(195, 193, 255, 0.1));
  }
  button:disabled {
    cursor: not-allowed;
    opacity: 0.8;
  }
  .normal {
    height: 3.6rem;
  }
  .small {
    height: 2.3rem;
  }
  .loading-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .primary {
    background: #423fd6;
  }
  .primary > div > div {
    color: #ffffff;
  }
  .primary:not([disabled]):active {
    box-shadow: 0 0 0 3px #b0afe2, inset 0px 50px 50px 0px rgba(255, 255, 255, 0.2);
  }
  .primary:not(:active):not([disabled]):hover {
    box-shadow: inset 0px 50px 50px 0px rgba(255, 255, 255, 0.2);
    filter: drop-shadow(0rem 0.3125rem 0.66rem rgba(0, 87, 255, 0.4));
  }
  .secondary {
    background: #c5c3ff;
  }
  .secondary > div > div {
    color: #423fd6;
  }
  .secondary:not([disabled]):active {
    box-shadow: 0 0 0 3px #828db4, inset 0px -25px 50px 0px rgba(0, 87, 255, 0.2);
  }
  .secondary:not(:active):not([disabled]):hover {
    box-shadow: inset 0px -25px 50px 0px rgba(66, 63, 214, 0.3);
    filter: drop-shadow(0rem 0.625rem 1.5rem rgba(195, 193, 255, 0.3));
  }
  .secondary-selected {
    background: #423fd6 !important;
  }
  .secondary-selected > div > div {
    color: #fff !important;
  }
  .classic {
    border: 0.78629px solid #33414f;
    background: var(--c-1);
  }
  .classic > div > div {
    color: #0b1220;
  }
  .classic:not([disabled]):active {
    box-shadow: 0 0 0 3px #33414f;
  }
  .classic:not(:active):not([disabled]):hover {
    box-shadow: inset 0px 50px 50px 0px rgba(42, 53, 77, 0.5);
    filter: drop-shadow(0rem 0.625rem 1.5rem rgba(195, 193, 255, 0.1));
  }

  .minimalist {
    background: #0b1220;
    font-weight: 400;
  }
  .minimalist > div > div {
    color: #ffffff;
  }

  button > * {
    pointer-events: none;
    transition: box-shadow 0.25s ease-in-out;
  }
  button > div > div {
    display: flex;
    align-items: center;
  }
</style>
